import AntragstellerMixin from "../AntragstellerMixin";

// @vue/component
export default {
  name: "AntragstellerAuswahl",
  mixins: [
    AntragstellerMixin,
  ],
};
